export function getTagContent(item, tag, callback) {
    if(item.getElementsByTagName(tag) === undefined || item.getElementsByTagName(tag)[0]===undefined || item.getElementsByTagName(tag)[0].textContent.trim()===""){

        return "";
    }
    if(callback instanceof Function) {
       return callback(item.getElementsByTagName(tag)[0].textContent.replace(/&quot;/g, '"'));
    }
    return item.getElementsByTagName(tag)[0].textContent.replace(/&quot;/g, '"').replace(/&nbsp;/g,' ');
}